import * as React from 'react';
import { Slot } from '@radix-ui/react-slot';
import { cva } from 'class-variance-authority';
import { cn } from '@/lib/utils';

const buttonVariants = cva(
  // Added transition-all, active scaling, robust focus rings, and SVG target rules
  'inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-all duration-200 active:scale-[0.98] focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0',
  {
    variants: {
      variant: {
        default:     'bg-primary text-primary-foreground shadow-xs hover:bg-primary/90',
        destructive: 'bg-destructive text-destructive-foreground shadow-xs hover:bg-destructive/90',
        outline:     'border border-border bg-transparent text-foreground shadow-xs hover:border-primary hover:text-primary',
        secondary:   'bg-secondary text-secondary-foreground hover:brightness-90 transition-all', // Smoothed out hover state
        ghost:       'text-muted-foreground hover:text-primary hover:bg-accent hover:text-accent-foreground',
        link:        'text-primary underline-offset-4 hover:underline',
        helm:        'bg-helm text-helm-foreground shadow-xs hover:bg-helm/80',
      },
      size: {
        default: 'h-9 px-4 py-2',    // Increased base height for better clickability
        sm:      'h-8 px-3 text-xs', // Shifted your original default to 'sm'
        lg:      'h-10 px-8',
        icon:    'h-9 w-9',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'default',
    },
  }
);

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : 'button';
  return (
    <Comp 
      className={cn(buttonVariants({ variant, size, className }))} 
      ref={ref} 
      {...props} 
    />
  );
});
Button.displayName = 'Button';

export { Button, buttonVariants };